export const projects = [
  {
    img: "https://raw.githubusercontent.com/ellite07/Fitmeals/main/img.jpeg",
    title: "Fitmeals-Clone",
    des: "This is the clone of Fitmeals website. A web application to buy Healthy food and diet plan. This is our team collaboration project at Full Stack-development bootcamp in Masai School.",
    demo: "",
    live: " https://fitmeals-project.netlify.app/",
    gitHub: "https://github.com/ellite07/Fitmeals",
    technologies: ["HTML", "CSS", "JavaScript","NodeJS"],
  },
  {
    img: "https://camo.githubusercontent.com/026c48765cd0c0a230b36f6b5fcf5b027e259b7eaaa6b17c635daea6ffe757f7/68747470733a2f2f696d67732e7365617263682e62726176652e636f6d2f424e522d315041584d773462677238473636684b42764e35497676566e4f6a687a725034736c49334a68672f72733a6669743a3736383a3438303a312f673a63652f6148523063484d364c79396a5a4734792f4c6d4a76645852706358566c4c6d68312f62574a735a5746755a484a70593267752f593239744c3364774c574e76626e526c2f626e5176645842736232466b637938792f4d4445354c7a41304c3031765a47567a2f5a57357a4c5445744e7a5934654451342f4d433571634763",
    title: "Modesens-Clone",
    des: "This is an actual Clothing web-application which sales Cloths Online.    I took inpiration from  https://modesens.com/",
    demo: "",
    live: "https://graceful-starlight-17a7a2.netlify.app//",
    gitHub: "https://github.com/ellite07/Modesens-Clone",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "NodeJS",
    ],
  }];
